import { Theme } from "@material-ui/core";

export const styles = (theme: Theme) => ({
  sidebar: {
    background: theme.palette.common.black,
    height: "100vh",
    left: 0,
    overflow: "hidden",
    position: "sticky" as "sticky",
    top: 0,
  },
});



// WEBPACK FOOTER //
// ./src/shared/components/sidebar/styles.ts